import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setToken, getToken, getSessionKind } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [shop, setShop] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!getToken()) { setUser(null); setShop(null); setLoading(false); return; }
    const kind = getSessionKind();
    try {
      if (kind === "shop") {
        const { data } = await api.get("/shop/me");
        setShop({ ...data, role: "shop" });
        setUser(null);
      } else {
        const { data } = await api.get("/auth/me");
        setUser(data);
        setShop(null);
      }
    } catch {
      setToken(null);
      setUser(null);
      setShop(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = (token, u) => {
    setToken(token, "user");
    setUser(u);
    setShop(null);
    // Reset any dismiss flags so per-login nudges (like the affiliate bank
    // reminder) reappear until the user actually completes the action.
    try { sessionStorage.removeItem("veloskin.affiliate.bank_prompt.dismissed"); } catch { /* ignore */ }
  };
  const loginShop = (token, s) => {
    setToken(token, "shop");
    setShop({ ...s, role: "shop" });
    setUser(null);
  };
  const logout = () => {
    setToken(null);
    setUser(null);
    setShop(null);
    try { sessionStorage.removeItem("veloskin.affiliate.bank_prompt.dismissed"); } catch { /* ignore */ }
  };
  // Aliases for shop-scoped screens (setup wizard, etc.)
  const logoutShop = logout;
  const refreshShop = refresh;

  return (
    <AuthContext.Provider value={{ user, shop, setUser, loading, login, loginShop, logout, logoutShop, refresh, refreshShop }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
